import styled from 'styled-components';

export const ResultsWrapper = styled.div`
  flex-grow: 1;
  text-align: center;
`;
